<div class="flex flex-col gap-8 h-full items-center system-page">
  <div class="logo"></div>
  <div class="flex-1 flex items-end">
    <h1>{{ appName }}</h1>
  </div>
  <div class="flex-1 flex flex-col gap-8 items-center">
    <ng-content></ng-content>
  </div>
</div>
